import { render, staticRenderFns } from "./dynamic-nav.vue?vue&type=template&id=44f4272d&"
import script from "./dynamic-nav.vue?vue&type=script&lang=js&"
export * from "./dynamic-nav.vue?vue&type=script&lang=js&"
import style0 from "./dynamic-nav.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports